import React, { useEffect, useState } from "react";
import { SlRefresh } from "react-icons/sl";
import { cn } from "../../../utils/cn";

interface Props {
    loading: boolean;
}

const Component = ({ loading }: Props) => {
    const [visible, setVisible] = useState(loading);

    useEffect(() => {
        if (loading) {
            setVisible(true);
        } else {
            const timer = setTimeout(() => setVisible(false), 300);
            return () => clearTimeout(timer);
        }
    }, [loading]);

    return visible ? (
        <SlRefresh
            className={cn(
                "h-8 w-8 animate-spin text-cpurple duration-300",
                loading ? "opacity-100" : "opacity-0",
            )}
        />
    ) : null;
};

export default Component;
